module.exports = __webpack_public_path__ + "img/hanukiah.f81fd569.svg";